import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { FaBuildingColumns, FaBookOpen, FaPeopleGroup } from "react-icons/fa6";
import { FaUsers, FaUserGraduate, FaChalkboardTeacher } from "react-icons/fa";
import Calendar from '../LMS_GRAPHS/Calendar'
import { useDispatch, useSelector } from 'react-redux';
import { dashboardRes, dashboardTodo } from '../../LMS_Redux/LMS_Slices/Dashboard/Dashboard';
import PropagateLoader from "react-spinners/PropagateLoader";
import { AnnouncementListRes, AnnouncementListTodo } from '../../LMS_Redux/LMS_Slices/Masters/AnnouncementList';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import PollResultGraph from './PollResultGraph';
import { pollDataRes, pollDataTodo } from '../../LMS_Redux/LMS_Slices/Assets/PollData';
import { useFormik } from 'formik';
import { SubmitPollSchema } from './DashboardSchema';
import { submitPollRes, submitPollTodo } from '../../LMS_Redux/LMS_Slices/Assets/SubmitPoll';
import { ToastContainer, toast } from 'react-toastify';
import UserStatistics from '../LMS_GRAPHS/UserStatistics';
import { trainingListRes, trainingListTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingList';
import { activeLoginsRes, activeLoginsTodo } from '../../LMS_Redux/LMS_Slices/Dashboard/ActiveLogins';
import ActiveLogins from '../LMS_GRAPHS/ActiveLogins';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';

export default function Dashboard() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const count = useSelector(state => state.dashboard && state.dashboard.data && state.dashboard.data.data && state.dashboard.data.data[0])
  const announcement = useSelector(state => state.announcementList && state.announcementList.data && state.announcementList.data.data)
  const traningCalender = useSelector(state => state && state.trainingList && state.trainingList.data && state.trainingList.data.data)
  const poll = useSelector(state => state.pollData && state.pollData.data && state.pollData.data.data)
  const active_login = useSelector(state => state.activeLogins && state.activeLogins.data && state.activeLogins.data.data)
  const [loading, setLoading] = useState(true)
  const [loadingAnnounce, setLoadingAnnounce] = useState(false)
  const [loadingPoll, setLoadingPoll] = useState(true)
  const [loadingCal, setLoadingCal] = useState(true)
  const [loadingLogin, setLoadingLogin] = useState(true)
  const [spinner, setSpinner] = useState(false)
  const [bool, setBool] = useState(false)
  // console.log(active_login)

  const initialValues = {
    poll_option: '',
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,
    validationSchema: SubmitPollSchema,

    onSubmit: (values, action) => {
      // console.log("new", values)
      setSpinner(true)
      dispatch(submitPollTodo({ 'option': values.poll_option, 'poll_id': poll.id })).then(() => poll_result())
      action.resetForm();
    },
  })

  const poll_result = () => {

    if (submitPollRes && submitPollRes.success) {
      toast.success(submitPollRes.message, { position: "bottom-right" });
      setBool(!bool)
      setSpinner(false)
    } else {
      toast.error(submitPollRes.message, { position: "bottom-right" });
      setBool(!bool)
      setSpinner(false)
    }
  }

  const dashboard_res = () => {
    if (dashboardRes && dashboardRes.success) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  const announcement_list_res = () => {
    if (AnnouncementListRes && AnnouncementListRes.success) {
      setLoadingAnnounce(false)
    } else {
      setLoadingAnnounce(false)
    }
  }

  const poll_res = () => {
    if (pollDataRes && pollDataRes.success) {
      setLoadingPoll(false)
    } else {
      setLoadingPoll(false)
    }
  }

  const training_res = () => {
    if (trainingListRes && trainingListRes.success) {
      setLoadingCal(false)
    } else {
      setLoadingCal(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    setLoadingAnnounce(true)
    setLoadingCal(true)
    dispatch(trainingListTodo()).then(() => training_res())
    dispatch(dashboardTodo()).then(() => dashboard_res())
    dispatch(AnnouncementListTodo(new Date())).then(() => announcement_list_res())

  }, [])

  useEffect(() => {
    setLoadingPoll(true)
    dispatch(pollDataTodo()).then(() => poll_res())
  }, [bool])

  const active_login_res = () => {
    if (activeLoginsRes && activeLoginsRes.success) {
      setLoadingLogin(false)
    } else {
      setLoadingLogin(false)
    }
  }

  useEffect(() => {
    const current_year = new Date().getFullYear()
    setLoadingLogin(true)
    dispatch(activeLoginsTodo(current_year)).then(() => active_login_res())
  }, [])

  return (
    <>
      <div className='container-fluid'>
        {loading ?
          <div className='row'>
            <div className="col mt-2 mt-md-4 mt-lg-0">
              <div className='box'>
                <div className='text-center mb-3'>
                  <PropagateLoader
                    color="#2262C6"
                    size={20}
                  />
                </div>
              </div>
            </div>
          </div>
          :
          <div className='row row-flex'>
            <div className="col-6 col-md-3 col-lg-2 mt-md-3 mt-sm-0 mt-lg-0">
              <Link to='/user_list'>
                <div className='box match_height'>
                  <div className='row'>
                    <div className="col">
                      <span className='box-icon box-icon-color1'><FaUsers /></span>
                    </div>
                  </div>
                  <h3 className='mt-4'>{count && count.user_list_count}</h3>
                  <p className='box-heading'>Total User</p>
                </div>
              </Link>
            </div>
            <div className="col-6 col-md-3 col-lg-2 mt-md-3 mt-sm-0 mt-lg-0">
              <div className='box match_height' onClick={() => navigate('/user_list', { state: 'GRD/1' })}>
                <div className='row'>
                  <div className="col">
                    <span className='box-icon box-icon-color2'><FaChalkboardTeacher /></span>
                  </div>
                </div>
                <h3 className='mt-4'>{count && count.instructor_count}</h3>
                <p className='box-heading text-warning'>Instructor</p>
              </div>
            </div>
            <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
              <div className='box match_height' onClick={() => navigate('/user_list', { state: 'GRD/2' })}>
                <div className='row'>
                  <div className="col">
                    <span className='box-icon box-icon-color3'><FaUserGraduate /></span>
                  </div>
                </div>
                <h3 className='mt-4'>{count && count.learner_count}</h3>
                <p className='box-heading txt-secondary'>Learner</p>
              </div>
            </div>
            <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
              <Link to='/department'>
                <div className='box match_height'>
                  <div className='row'>
                    <div className="col">
                      <span className='box-icon box-icon-color4'><FaBuildingColumns /></span>
                    </div>
                  </div>
                  <h3 className='mt-4'>{count && count.dept_list_count}</h3>
                  <p className='box-heading' style={{ color: '#009688' }}>Department</p>
                </div>
              </Link>
            </div>
            <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
              <Link to='/course_list'>
                <div className='box match_height'>
                  <div className='row'>
                    <div className="col">
                      <span className='box-icon box-icon-color1'><FaBookOpen /></span>
                    </div>

                  </div>
                  <h3 className='mt-4'>{count && count.course_list_count}</h3>
                  <p className='box-heading text-success-teal'>Learning Modules</p>
                </div>
              </Link>
            </div>
            <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
              <Link to='/group_list'>
                <div className='box match_height'>
                  <div className='row'>
                    <div className="col">
                      <span className='box-icon box-icon-color2'><FaPeopleGroup /></span>
                    </div>

                  </div>
                  <h3 className='mt-4'>{count && count.group_list}</h3>
                  <p className='box-heading text-warning'>Groups</p>
                </div>
              </Link>
            </div>
          </div>
        }

        <div className="row row-flex">
          <div className="col-12 col-md-5 mt-4">
            {loadingAnnounce ?
              <div className='wrapper-admin'>
                <div className="widget-heading">
                  <h5 className="">Announcements</h5>
                </div>
                <div className='text-center mb-4'>
                  <PropagateLoader
                    color="#2262C6"
                    size={20}
                  />
                </div>
              </div>
              :
              <div className='wrapper-admin match_height'>
                <div className="anounce-ment">
                  <div className="widget-heading">
                    <h5 className="">Announcements</h5>
                  </div>
                  <div>
                    <PerfectScrollbar>
                      {announcement && announcement.length ?
                        announcement && announcement.map((value, index) =>
                          <div className={index % 2 == 0 ? "card-body bg-primary-subtle rounded p-2" : "card-body bg-warning-subtle rounded p-2"} key={index} >
                            <h5 className="card-title">{value.announcement_title}</h5>
                            <p>{value.description}</p>
                            <p className='badge text-bg-dark'>Date: {moment(value.createdAt).format('DD/MM/YYYY')}</p>
                          </div>
                        )
                        :
                        "No Announcement Available"
                      }
                    </PerfectScrollbar>
                  </div>
                </div>
              </div>
            }
          </div>

          <div className="col-12 col-md-7 mt-4">
            <div className='wrapper-admin match_height'>
              <div className="anounce-ment">
                <div className="widget-heading">
                  <h5 className="">Poll</h5>
                </div>
                {loadingPoll ?
                  <div className='text-center mb-4'>
                    <PropagateLoader
                      color="#2262C6"
                      size={20}
                    />
                  </div>
                  :
                  poll && poll.hasOwnProperty('res') ?
                    !poll.res ?
                      <>
                        <div className='poll_result'>
                          <span>{poll && poll.poll_title && poll.poll_title}</span>
                        </div>

                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                          <div className="d-flex justify-content-around align-items-center">
                            {poll && poll.poll_option1 &&
                              <div className="form-check mt-2">
                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                  value='A' onChange={handleChange} onBlur={handleBlur}
                                />
                                <label className="form-check-label" htmlFor="">
                                  {poll && poll.poll_option1 && poll.poll_option1}
                                </label>
                              </div>
                            }

                            {poll && poll.poll_option2 &&
                              <div className="form-check mt-2">
                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                  value='B' onChange={handleChange} onBlur={handleBlur}
                                />
                                <label className="form-check-label" htmlFor="">
                                  {poll && poll.poll_option2 && poll.poll_option2}
                                </label>
                              </div>
                            }

                            {poll && poll.poll_option3 &&
                              <div className="form-check mt-2">
                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                  value='C' onChange={handleChange} onBlur={handleBlur}
                                />
                                <label className="form-check-label" htmlFor="">
                                  {poll && poll.poll_option3 && poll.poll_option3}
                                </label>
                              </div>
                            }

                            {poll && poll.poll_option4 &&
                              <div className="form-check mt-2">
                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                  value='D' onChange={handleChange} onBlur={handleBlur}
                                />
                                <label className="form-check-label" htmlFor="">
                                  {poll && poll.poll_option4 && poll.poll_option4}
                                </label>
                              </div>
                            }
                          </div>
                          {errors.poll_option && touched.poll_option ? (<span className='text-danger form_label' > {errors.poll_option}</span>) : null}

                          <div className='text-end mt-4'>
                            <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                              {spinner ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  className='ms-2'
                                />
                                : ''
                              }</button>
                          </div>
                        </form>
                      </>
                      :
                      <PollResultGraph poll_data={poll} />
                    :
                    'No Poll Available'
                }

              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4 row-flex">
          <div className="col-12 col-md-6">
            {loadingLogin ?
              <div className="wrapper-admin">
                <div className='text-center mb-3'>
                  <PropagateLoader
                    color="#2262C6"
                    size={20}
                  />
                </div>
              </div>
              :
              <div className='wrapper-admin match_height'>
                <div className='dash_head d-flex justify-content-between'>
                  <h5>Active Logins</h5>
                  <select className="form-select form_input" aria-label="Default select example" style={{ width: '200px' }}
                    defaultValue={new Date().getFullYear()}
                    onChange={(e) => {
                      // setLoadingLogin(true)
                      dispatch(activeLoginsTodo(e.target.value)).then(() => active_login_res())
                    }}
                  >
                    {active_login && active_login.filter((o, i) => i == 0)[0].years.map((val, index) =>
                      <option value={val} key={index} >{val}</option>
                    )}
                  </select>
                </div>

                <ActiveLogins graph={active_login} />
              </div>
            }
          </div>

          <div className="col-12 col-md-6 mt-4 mt-md-0">
            {loading ?
              <div className="wrapper-admin">
                <div className='text-center mb-3'>
                  <PropagateLoader
                    color="#2262C6"
                    size={20}
                  />
                </div>
              </div>
              :
              <div className='wrapper-admin match_height'>
                <UserStatistics userStatistics={count && count.user_statistics} />
              </div>
            }
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-12 mt-4 mt-md-4">
            {loadingCal ?
              <div className="wrapper-admin">
                <div className='text-center mb-3'>
                  <PropagateLoader
                    color="#2262C6"
                    size={20}
                  />
                </div>
              </div>
              :
              <div className="wrapper-admin">
                <Calendar calendar={traningCalender} />
              </div>}
          </div>

        </div>

      </div>
      <ToastContainer />
    </>
  )
}
